<template>
  <div class="discover-arch"></div>
  <div style="width: 100%; position: absolute; z-index: -1" ref="archElement">
    <svg
      class="full-arch"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1052 2434"
      style="transform: scaleX(-1)"
    >
      <path
        class="arch"
        d="M547.33,471.28C305.35,804.5,136.5,1557.72,136.5,2433.5H443.14c0-858.93,104.65-1590.88,251.28-1870.45Z"
        fill="#ffbc0d"
      ></path>
      <path
        class="arch-mask"
        d="M288.53,2433.5c0-875.78,140.15-1619.06,349.38-1941.63"
        fill="none"
        stroke="#fff"
        stroke-miterlimit="10"
        stroke-width="410"
        stroke-dasharray="1992.531982421875"
        style="stroke-dashoffset: 1992.53px"
      ></path>
      <!-- <image id="happy-meal" width="1000" height="767" transform="translate(0.3 1.3) scale(1.05)"
                xlink:href="/sites/all/themes/mcdonalds/images/frontpage/happy-meals-smilebox.png"></image> -->
    </svg>
  </div>
</template>

<script>
import anime from "animejs/lib/anime.es.js";

export default {
  name: "arch-animation-component",

  mounted() {
    // Define the animation
    const slideAnimation = anime({
      targets: ".full-arch .arch-mask",
      strokeDashoffset: [0, anime.setDashoffset],
      duration: 5000,
      easing: "easeInOutSine",
      loop: false,
    });

    let playedAnimation = false;
    // Trigger the animation on scroll
    window.addEventListener("scroll", () => {
      const el = document.querySelector(".discover-arch");
      if (el && el.getBoundingClientRect()) {
        const rect = el.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // Check if the element is in the viewport
        if (rect.top < windowHeight && rect.bottom >= 0) {
          // Do something when the element is visible
          if (!playedAnimation) {
            slideAnimation.play();
            playedAnimation = true;
          }
        } else {
          playedAnimation = false;
        }
      }
    });
  },
};
</script>

<style>
.discover-arch {
  height: 10vh; /* Adjust as needed */
}
</style>
